import React from 'react';
import { getAssetUrl, IMAGE_SIZES } from '../../../utils/directus';
import { Image } from '@/components/common/Image';
import { IMAGE_PLACEHOLDER_CLASSES } from '@/config/imageDefaults';

interface GalleryImage {
  id: string;
  alt: string;
  size?: 'full';
}

interface GalleryProps {
  images: GalleryImage[];
}

const Gallery: React.FC<GalleryProps> = ({ images }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
      {images.map((image, index) => (
        <div
          key={image.id}
          className={image.size === 'full' ? 'md:col-span-2' : ''}
        >
          <Image
            src={getAssetUrl(image.id, IMAGE_SIZES.gallery)}
            alt={image.alt}
            className="w-full h-full object-cover rounded-lg"
            placeholderClassName={IMAGE_PLACEHOLDER_CLASSES.card}
          />
        </div>
      ))}
    </div>
  );
};

export default Gallery;